import Vue from 'vue'

const STORAGE_KEY = 'jiangk-admin-theme'
export const supportedAdminThemes = ['system', 'light', 'dark']
const saved = window.localStorage.getItem(STORAGE_KEY)

export const adminThemeState = Vue.observable({
  preference: supportedAdminThemes.includes(saved) ? saved : 'system',
  systemDark: window.matchMedia('(prefers-color-scheme: dark)').matches
})

let media
function effectiveTheme() {
  return adminThemeState.preference === 'system'
    ? (adminThemeState.systemDark ? 'dark' : 'light')
    : adminThemeState.preference
}
function applyTheme() {
  const dark = effectiveTheme() === 'dark'
  document.body.classList.toggle('admin-theme-dark', dark)
  document.body.classList.toggle('admin-theme-light', !dark)
  document.documentElement.dataset.adminTheme = adminThemeState.preference
  document.documentElement.style.colorScheme = dark ? 'dark' : 'light'
}
function onSystemTheme(event) {
  adminThemeState.systemDark = event.matches
  if (adminThemeState.preference === 'system') applyTheme()
}
export function startAdminTheme() {
  if (!media) {
    media = window.matchMedia('(prefers-color-scheme: dark)')
    adminThemeState.systemDark = media.matches
    if (media.addEventListener) media.addEventListener('change', onSystemTheme)
    else media.addListener(onSystemTheme)
  }
  applyTheme()
}
export function stopAdminTheme() {
  if (media) {
    if (media.removeEventListener) media.removeEventListener('change', onSystemTheme)
    else media.removeListener(onSystemTheme)
    media = null
  }
  document.body.classList.remove('admin-theme-dark', 'admin-theme-light')
  document.documentElement.removeAttribute('data-admin-theme')
  document.documentElement.style.colorScheme = ''
}
export function setAdminTheme(preference) {
  const next = supportedAdminThemes.includes(preference) ? preference : 'system'
  adminThemeState.preference = next
  window.localStorage.setItem(STORAGE_KEY, next)
  applyTheme()
}
export function resolvedAdminTheme() { return effectiveTheme() }
